import {FC} from "react";

import classes from "./PartnersPage.module.css";

const PartnersPage: FC = () => {
    return (
        <main className='container'>
            <h2 className={classes.title}>PARTNERIAI</h2>
            <section className={classes.section}>
                <div>
                    <img src={require('./img/diaspora.jpeg')} alt=""/>
                    <span>Ukrainiečių diaspora užsienyje</span>
                </div>
                <div>
                    <img src={require('./img/medical.jpeg')} alt=""/>
                    <span>Ukrainos medicinos įstaigos</span>
                </div>
                <div>
                    <img src={require('./img/zsy.png')} alt=""/>
                    <span>Ukrainos Ginkluotosios pajėgos</span>
                </div>
                <div>
                    <img src={require('./img/miu.png')} alt=""/>
                    <span>Ukrainos Infrastruktūros ministerija</span>
                </div>
                <div>
                    <img src={require('./img/mozu.jpeg')} alt=""/>
                    <span>Ukrainos Sveikatos apsaugos ministerija</span>
                </div>
                <div>
                    <img src={require('./img/mou.png')} alt=""/>
                    <span>Ukrainos Gynybos ministerija</span>
                </div>
            </section>
        </main>
    )
}

export default PartnersPage
